export default {
  'filter_confirm': '确认',
  'filter_reset': '重置',
  'filter_contrast':'对比日',
  'filter_filter_contrast':'对比日',
  'filter_lock_open_message': '点击锁定筛选器，当切换同一游戏的不同页面时，页面会按照此筛选器展示数据。',
  'filter_lock_close_message': '点击解锁筛选器，当切换同一游戏的不同页面时，筛选器恢复默认设置。',
  'filter_lock_success': '锁定成功',
  'filter_lock_fail': '解锁成功',
  'filter_lock_expend_message':'更改筛选条件后，需要点击Confirm刷新页面',
  'filter_show_message':'展开',
  'filter_close_message':'收起',
  'filter_save_error_message':  "已有相同命名的保存方案，保存失败。",
  'filter_save_statistics_date': "统计日期",
  'filter_save_my_filter': "我的筛选",
  'filter_save_up_to_10': " 最多可保存10个方案",
  'filter_save_setting': "保存筛选设置",
  'filter_save_can_be_use': "除UA页面外所有报表均可使用保存的筛选方案。",
  'filter_save_setting_name': "方案名称",
  'filter_save_to_be_save':'被保存项',
  'filter_save_delete':'删除',
  'filter_save_delete_success':'删除成功',
  'filter_save_delete_fail':'删除失败',
  'filter_save_save_success':'保存成功',
  'filter_edit_success':'编辑成功',
  'filter_save_save_fail':'保存失败',
  'filter_edit_fail':'编辑失败',
  'filter_save_delete_setting':'确认删除方案？',
  'filter_save_sure_to_delete':'是否确认删除 {name}？删除后不可恢复，请谨慎操作！',
  'filter_save_enter_a_name':'请输入名称',
  'filter_save_search_placeholder': "搜索筛选器方案",
  'filter_save_no_data':'暂无方案',
  'filter_edit_setting': "编辑筛选设置",
  'filter_edit_error_message':  "已存在名称相同的设置，单击保存以替换此设置。",
  'filter_default_setting':  "设置为每个报表的默认值。",
  'filter_default_setting_funnel':  "设置为默认值。",
  'filter_setting':  "筛选设置",
  'filter_edit_same_name_success':'{name} 筛选保存配置已更新',
  'filter_save_time_setting':'时间维度',
  'filter_save_other_setting':'其他选项',
  'filter_save_latest_date':'近期时段',  
  'filter_save_setting_title':'提供两种时间保存方式：',
  'filter_save_setting_info_start_end':'开始&结束时间：使用时间筛选器的开始至结束时间。举例，本方案保存后，该方案将固定查询【{start}~{end}】的数据。',
  'filter_save_setting_info_duration':'近期时段：时间筛选器最近1次选中的右侧快捷时间选项，将显示在此处。举例，本方案保存后，将使用【{latestValue}】作为固定时间选项进行查询。',
  'filter_save_last_day':'昨天',
  'filter_save_last_week':'上周',
  'filter_save_last_month':'上月',
  'filter_save_last_single_day':'当天',
  'filter_general_filter': '普通筛选',
  'filter_event_filter': '事件筛选',
  'filter_event_name': '事件名称',
  'filter_event_parameter': '事件参数',
  'filter_hours_since_register': '注册时长(h)',
  'filter_event_occur_count': '事件触发次数',
  'filter_event_occur_count_range_error': '右侧框的值必须大于等于左侧框内的值',
  'filter_hours_max_exceeded': '最大值不可超过168',
  'filter_all_event': '全部事件',
  'filter_please_select': '请选择',
  'filter_please_select_value': '请选择值',
  'filter_numbers': '数字',
  'filter_cancel': '取消',
  'filter_custom': '自定义',
  'filter_overall': '聚合数据',
  'filter_dimension_filter': '维度',
  'filter_dimension_all_info': '展示所有维度的去重用户数据',
  'filter_event_occur_count_integer_error': '请输入整数',
};
